import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import Raven from 'raven-js';
import { useEffect } from 'react';
import { getPaidUserManagementUrl } from 'self-service-api/core/utilities/links';
import * as tracker from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import { getUpgradeDataTrackingProperties, trackPotentialBannerInteraction } from 'ui-addon-upgrades/ums/utils';
import { omit } from 'ui-addon-upgrades/utils';
import withErrorBoundary from '../ErrorBoundary';
import { UI_ASSIGN_SEAT_BUTTON } from '../_core/common/constants/ErrorBoundaryNames';
import { jsx as _jsx } from "react/jsx-runtime";
const AssignSeatButton = props => {
  const {
    upgradeData,
    level,
    usageLimitBannerData
  } = props;
  const propsToPass = omit(props, 'isUpgradePoint', 'upgradeData', 'location', 'subscreen', 'level', 'usageLimitBannerData', 'canViewNewSeats');
  useEffect(() => {
    tracker.track('interaction', Object.assign({
      action: 'viewed assign seat',
      isPrimaryCta: level === 1,
      isSecondaryCta: level === 2
    }, usageLimitBannerData, getUpgradeDataTrackingProperties(upgradeData)));
  }, [upgradeData, usageLimitBannerData, level]);
  const trackClick = () => {
    tracker.track('interaction', Object.assign({
      action: 'clicked upgrade point'
    }, usageLimitBannerData, getUpgradeDataTrackingProperties(upgradeData)));
    tracker.track('interaction', Object.assign({
      action: 'clicked assign seat',
      isPrimaryCta: level === 1,
      isSecondaryCta: level === 2
    }, usageLimitBannerData, getUpgradeDataTrackingProperties(upgradeData)));
    const {
      pointType,
      upgradeKey
    } = upgradeData;
    trackPotentialBannerInteraction(pointType, upgradeKey).catch(error => {
      Raven.captureException(new Error('Failed to submit interaction from UIAssignSeatButton'), {
        extra: {
          error
        }
      });
    });
  };
  return /*#__PURE__*/_jsx(UIButton, Object.assign({
    "data-test-id": "assign-seat-button"
  }, propsToPass, {
    href: getPaidUserManagementUrl(),
    external: true,
    onClick: trackClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "upgrades.assignSeatButton"
    })
  }));
};
export default withErrorBoundary(AssignSeatButton, {
  boundaryName: UI_ASSIGN_SEAT_BUTTON
});